.header {
  height: 4rem;
  min-height: 4rem;
  border-bottom: 1px var(--content-border-color) solid;
  color: #e3e4e7;
  font-size: 1.3rem;
  font-weight: 600;
  padding: 0 1.6rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  justify-content: space-between;
  cursor: default;
}

.header-document {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: var(--spacing-gap-sm);
}
